import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const InstituteList = Loadable(
  lazy(() => import("features/institute/components/List"))
);
const InstitutePage = Loadable(
  lazy(() => import("features/institute/components/Page"))
);

const routes = {
  path: "institute",
  children: [
    { path: "", element: <InstituteList /> },
    { path: "add", element: <InstitutePage /> },
    { path: "edit/:instituteId?", element: <InstitutePage /> },
  ],
};

export default routes;
